export enum TaskTypeTitles {
  GeneralTasks = 'General Tasks',
  PeopleTasks = 'People Tasks',
}
